import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=31f4294e&scoped=true&"
import script from "./Steps.vue?vue&type=script&lang=ts&"
export * from "./Steps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4294e",
  null
  
)

export default component.exports